import { Check, Close, MoreVert, Visibility } from "@mui/icons-material";
import {
    CircularProgress,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
} from "@mui/material";
import { MouseEvent, useState } from "react";

import { Withdrawal } from "../../interfaces/withdrawal";

interface ActionMenuProps {
    data: Withdrawal;
    onClickDetails?: () => void;
    onClickApprove?: () => void;
    onClickReject?: () => void;
    loading?: boolean;
}

export function ActionMenu({
    data,
    onClickDetails,
    onClickApprove,
    onClickReject,
    loading,
}: ActionMenuProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.currentTarget.blur();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickDetails = () => {
        onClickDetails?.();
        handleClose();
    };

    const handleClickApprove = () => {
        onClickApprove?.();
        handleClose();
    };

    const handleClickReject = () => {
        onClickReject?.();
        handleClose();
    };

    return (
        <>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                disabled={loading}
            >
                {loading ? (
                    <CircularProgress size={18} color="inherit" />
                ) : (
                    <MoreVert color="action" />
                )}
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClickDetails}>
                    <ListItemIcon>
                        <Visibility fontSize="small" color="action" />
                    </ListItemIcon>
                    <ListItemText>Ver detalhes</ListItemText>
                </MenuItem>

                {data.status === "pending" && (
                    <MenuItem onClick={handleClickApprove}>
                        <ListItemIcon>
                            <Check fontSize="small" color="success" />
                        </ListItemIcon>
                        <ListItemText>Aprovar</ListItemText>
                    </MenuItem>
                )}

                {data.status === "pending" && (
                    <MenuItem onClick={handleClickReject}>
                        <ListItemIcon>
                            <Close fontSize="small" color="error" />
                        </ListItemIcon>
                        <ListItemText>Recusar</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}
